import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Button design="default">Default</Button>
		<Button design="primary">Primary</Button>
		<Button design="secondary">Secondary</Button>
		<Button design="outline">Outline</Button>
		<Button design="link">Link</Button>
		<Button design="linkSubtle">Link Subtle</Button>
	</CssColumnGrid>
);